import {
  BaseLayout,
  Navigation,
  Skeleton,
  DefaultPageSkeleton
} from '@efast_public/fjd-component-library';

export function BehLayoutSkeleton() {
  return (
    <BaseLayout
      footer={<Skeleton width={1000} height={40} />}
      header={<Skeleton width={200} height={40} />}
      navigation={
        <Navigation>
          <Navigation.NavigationItem
            icon="table-split"
            label={'Antragsübersicht'}
            disabled
          />
          <Navigation.NavigationItem
            icon="edit"
            label={'Schreibtisch'}
            disabled
          />
        </Navigation>
      }
      mainContent={<DefaultPageSkeleton />}
    />
  );
}
